module.exports = __webpack_public_path__ + "img/home-heading-image.png?0bd0cc602e2d72cfee1cd8b31dd69867";